<template>
  <div class="List">
    <van-sticky :offset-top="0">
      <van-nav-bar :title="title" left-arrow @click-left="onClickLeft">
      </van-nav-bar>
    </van-sticky>
    <van-cell title="联系人信息" v-if="id && showEdit">
      <template #right-icon>
        <van-button
          type="info"
          size="small"
          v-if="!editFlg"
          @click="editFlg = true"
          >编辑</van-button
        >
        <van-button type="info" size="small" v-else @click="getContact"
          >取消</van-button
        >
      </template>
    </van-cell>
    <van-form validate-first @submit="onSubmit">
      <van-field
        v-model="name"
        input-align="right"
        label="客户"
        maxlength="20"
        placeholder="-"
      />
      <van-field
        v-model="formdate.name"
        input-align="right"
        required
        :readonly="!editFlg"
        label="联系人名称"
        :placeholder="editFlg ? '请输入联系人名称' : '-'"
      />
      <van-field
        type="number"
        v-model="formdate.mobile"
        :readonly="!editFlg"
        input-align="right"
        label="手机号"
        maxlength="11"
        :rules="mobileRules(formdate.mobile)"
        :placeholder="editFlg ? '请输入手机号' : '-'"
      />
      <van-field
        type="number"
        v-model="formdate.telephone"
        :readonly="!editFlg"
        input-align="right"
        label="电话"
        maxlength="11"
        :rules="mobileRules(formdate.telephone)"
        :placeholder="editFlg ? '请输入电话' : '-'"
      />
      <van-field
        v-model="formdate.post"
        :readonly="!editFlg"
        input-align="right"
        label="职位"
        maxlength="11"
        :placeholder="editFlg ? '请输入职位' : '-'"
      />
      <van-field
        input-align="right"
        readonly
        label="关键决策人"
        :placeholder="editFlg ? '请选择' : '-'"
      >
        <template #input>
          <van-radio-group :disabled="!editFlg" v-model="formdate.master">
            <van-radio name="true">是</van-radio>
            <van-radio name="false">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        :value="formdate.sex | enumMessage(AllEnums.SYSTEM_USER_SEX)"
        input-align="right"
        readonly
        label="性别"
        @click="openPicker('sex')"
        :placeholder="editFlg ? '请选择' : '-'"
      />
      <van-field
        :value="formdate.parentId | enumMessage(parentList)"
        input-align="right"
        readonly
        label="直属上级"
        @click="openPicker('parentId')"
        :placeholder="editFlg ? '请选择' : '-'"
      />
      <van-field
        v-model="formdate.areaName"
        input-align="right"
        readonly
        label="客户地址"
        @click="openPicker('area')"
        :placeholder="editFlg ? '请选择' : '-'"
      />
      <van-field
        v-model="formdate.detailAddress"
        input-align="right"
        rows="2"
        type="textarea"
        autosize
        :readonly="!editFlg"
        maxlength="100"
        label="详细地址"
        :show-word-limit="editFlg"
        :placeholder="editFlg ? '请输入详细地址' : '-'"
      />
      <van-field
        v-model="formdate.remark"
        input-align="right"
        rows="2"
        autosize
        :readonly="!editFlg"
        label="备注"
        type="textarea"
        maxlength="250"
        :show-word-limit="editFlg"
        :placeholder="editFlg ? '请输入备注' : '-'"
      />
      <div class="bottom-btn" v-if="(id && editFlg) || !id">
        <div class="btns">
          <van-button round block type="info" native-type="submit"
            >保存</van-button
          >
        </div>
      </div>
    </van-form>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        v-if="['sex'].includes(actionType)"
        show-toolbar
        :columns="AllEnums.SYSTEM_USER_SEX"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
      <van-picker
        v-if="['parentId'].includes(actionType)"
        show-toolbar
        :columns="parentList"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
      <van-picker
        v-if="['area'].includes(actionType)"
        show-toolbar
        :columns="areaList"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import Api from "@/api/user";
import { Form, Field, Toast, NoticeBar, sticky, RadioGroup, Radio } from "vant";
import { idCodeReg } from "@/plugins/common";
Vue.use(sticky);
Vue.use(Form);
Vue.use(Field);
Vue.use(NoticeBar);
Vue.use(RadioGroup);
Vue.use(Radio);
export default {
  data() {
    return {
      idCodeReg,
      userBaseInfo: {},
      formdate: {
        master: "false",
      },
      showPicker: false,
      actionType: "",
      areaList: [], // 地区
      parentList: [], // 上级
      id: "",
      editFlg: false,
      showEdit: true,
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (!this.id) {
      this.editFlg = true;
    } else {
      this.getContact();
    }
  },
  computed: {
    title() {
      if (this.id && !this.editFlg) return "查看联系人";
      return this.id ? "编辑联系人" : "新增联系人";
    },
    name() {
      return this.$route.query.name;
    },
  },
  async mounted() {
    let { data: areaList } = await Api.areaList();
    this.areaList = this.setAreaListName(areaList);
    this.getContactsList();
  },
  methods: {
    mobileRules(value) {
      if (value) {
        return [
          { required: true, message: "请输入手机号" },
          { pattern: /^1[3456789]\d{9}$/, message: "手机号码格式错误！" },
        ];
      } else {
        return [{ required: false, message: "" }];
      }
    },
    async getContactsList() {
      const params = {
        pageNo: 1,
        pageSize: 20,
        customerId: this.$route.query.customerId,
      };
      const { data } = await Api.getContactsList(params);
      this.parentList = (data.list || []).map((item) => {
        return {
          ...item,
          value: item.id,
          text: item.name,
        };
      });
    },
    // 递归将areaList内的name改成text,最后返回areaList
    setAreaListName(arr) {
      return arr.map((item) => {
        item.text = item.name;
        if (item.children && item.children.length > 0) {
          this.setAreaListName(item.children);
        } else {
          delete item.children;
        }
        return item;
      });
    },
    async onSubmit(values) {
      console.log("submit", values);
      await this.operatorRegister();
    },
    // 新建联系人
    async operatorRegister() {
      if (this.sbumiting) return;
      try {
        this.sbumiting = true;
        const result = await Api.createContact({
          ...this.formdate,
          customerId: this.$route.query.customerId,
          ownerUserId: this.userBaseInfo.userId,
        });
        Toast.success({
          message: result.message,
        });
        setTimeout(() => {
          this.sbumiting = false;
          this.$router.go(-1);
        }, 1500);
      } catch (error) {
        this.sbumiting = false;
        Toast.fail(error);
      }
    },
    // 获取联系人
    async getContact() {
      if (this.sbumiting) return;
      try {
        this.sbumiting = true;
        const result = await Api.getContact({
          id: this.id,
        });
        this.formdate = result.data;
        this.$set(this.formdate, "master", this.formdate.master.toString());
        this.sbumiting = false;
        this.editFlg = false;
      } catch (error) {
        console.log("error :>> ", error);
        this.sbumiting = false;
        this.showEdit = false;
        Toast.fail(error);
      }
    },
    // 编辑联系人
    async operatorEdit() {
      if (this.sbumiting) return;
      try {
        this.sbumiting = true;
      } catch (error) {
        this.sbumiting = false;
        Toast.fail(error);
      }
    },

    openPicker(actionType) {
      if (!this.editFlg) return;
      this.actionType = actionType;
      this.showPicker = true;
    },
    onConfirm(value, index) {
      switch (this.actionType) {
        case "sex":
        case "parentId":
          this.formdate[this.actionType] = value.value;
          break;
        case "area":
          this.formdate.areaId = this.getAreaIdByIndex(index).pop();
          this.$set(this.formdate, "areaName", value.join(" "));
          break;
        default:
          break;
      }
      this.showPicker = false;
    },
    getAreaIdByIndex(index) {
      let city = this.areaList[index[0]];
      let area = city.children[index[1]];
      let street = area.children[index[2]];
      return [city.id, area.id, street.id];
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-uploader__upload {
  background: #efefef;
}
/deep/.van-radio-group {
  display: flex;
  .van-radio {
    margin-left: 15px;
  }
}
</style>
